import React from "react";
import UploadIcon from "../../svgs/upload.svg";

const InventoryUploadField = ({
  idx,
  uploadedImage,
  handleImageChange,
  disabled = false,
}) => {
  const handleFileChange = (e) => {
    if (disabled) return;

    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        handleImageChange(file);
      } else {
        alert("Please upload only image files.");
      }
    }
    e.target.value = "";
  };

  const getImagePreview = () => {
    console.log("Image", uploadedImage);
    if (uploadedImage) {
      if (typeof uploadedImage === "string") {
        return uploadedImage;
      } else if (uploadedImage instanceof File) {
        return URL.createObjectURL(uploadedImage);
      }
    }
    return UploadIcon;
  };

  const isImageUploaded = uploadedImage && uploadedImage !== null;

  return (
    <div className="inventory-upload-field">
      <label
        className={`inventory-upload-label ${disabled ? "disabled" : ""} ${
          isImageUploaded ? "has-image" : ""
        }`}
        htmlFor={`upload-${idx}`}
      >
        <div className="inventory-upload-preview">
          <img
            src={getImagePreview()}
            alt="Upload preview"
            className={`inventory-upload-icon ${
              isImageUploaded ? "uploaded-image" : ""
            }`}
            onError={(e) => {
              e.target.src = UploadIcon;
            }}
          />
          {isImageUploaded && (
            <div className="image-overlay">
              <span className="change-text">Change</span>
            </div>
          )}
        </div>
        <span className="upload-text">
          {isImageUploaded ? "Change Image" : "Upload Image"}
        </span>
      </label>
      <input
        id={`upload-${idx}`}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
        disabled={disabled}
      />
    </div>
  );
};

export default InventoryUploadField;
